import { has, isObject } from 'lodash-es';
import { TradeWay } from 'models/TradeWay';
import { getXMarginValue } from 'state/formData/formData.helper';
import type { DataById, XMarginData } from 'state/formData/formData.model';

export function isOnBehalf(client: unknown) {
  return isObject(client);
}

export function isPatchingSolvingMode(patch: DataById) {
  return has(patch, 'SolvingMode');
}

export function isPatchingCustomizedXMarginWithNullValue(patch: DataById) {
  const xMarginData = patch['XMargin'] as XMarginData | undefined;
  if (xMarginData === undefined) {
    return false;
  }

  return isObject(xMarginData) && getXMarginValue(xMarginData) === null;
}

export function getFieldIdsWithNullValue(formData: DataById, fieldIds: readonly string[]) {
  return fieldIds.filter(fieldId => {
    if (fieldId === 'XMargin') {
      const xMarginData = formData[fieldId] as XMarginData | undefined;
      return xMarginData === undefined ? false : getXMarginValue(xMarginData) === null;
    }
    return formData[fieldId] === null;
  });
}

export function getSgSideByTradeWay(tradeWay?: TradeWay) {
  if (tradeWay === 'Buy') {
    return 'BUY';
  }

  if (tradeWay === 'Sell') {
    return 'SELL';
  }

  return undefined;
}

export function getSide(isExecOnlyAddon = false, tradeWay?: TradeWay) {
  return isExecOnlyAddon ? undefined : getSgSideByTradeWay(tradeWay);
}
